import { RootState } from '../types';
import { storeResources } from '../resources';
import { ITechnicianConfirmationRequest, IVerificationRequest } from '../../constants/pusher';

export const VerificationRequestSelector = (state: RootState): IVerificationRequest | null =>
  state[storeResources.VERIFICATION_REQUEST].request;
export const VerificationPendingSelector = (state: RootState): boolean =>
  state[storeResources.VERIFICATION_REQUEST].isPending;
export const VerificationErrorSelector = (state: RootState): string | undefined =>
  state[storeResources.VERIFICATION_REQUEST].error;

export const TechnicianConfirmationSelector = (
  state: RootState,
): ITechnicianConfirmationRequest | null =>
  state[storeResources.VERIFICATION_REQUEST].technicianConfirmation;

export const VerificationModalOpenSelector = (state: RootState): boolean =>
  state[storeResources.VERIFICATION_REQUEST].verificationModalOpen;

export const ShowTechnicianConfirmationModalSelector = (state: RootState): boolean =>
  state[storeResources.VERIFICATION_REQUEST].showTechnicianConfirmationModal;
